import { render, staticRenderFns } from "./DocPencil.vue?vue&type=template&id=ffbef67a"
import script from "./DocPencil.vue?vue&type=script&lang=js"
export * from "./DocPencil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports